import ApiService from '@/services/core/api.service'

const MasterDataService = {
  async get (query) {
    return ApiService.get(`agent/master-data?${query}`)
  },

  async post (payload) {
    return ApiService.post('agent/master-data', payload)
  },

  async put (payload) {
    return ApiService.put(`agent/master-data/${payload.id}`, payload)
  }
}

export default MasterDataService
